import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900 text-white">
      <h1 className="text-6xl font-bold text-chotto-gold mb-4">404</h1>
      <p className="text-xl text-neutral-300 mb-8">Oops! Page Not Found.</p>
      <Button asChild variant="link" className="text-lg text-chotto-gold">
        <Link to="/">Go back home</Link>
      </Button>
    </div>
  );
};

export default NotFoundPage;
